import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
//import Grid from '@material-ui/core/Grid';
import { getGlobalClasses } from '../themes';
import { Link } from 'react-router-dom';
import driverReportIcon from '../images/icons/driverReportsColored.svg';
import Grid from '@material-ui/core/Grid';
import { gridMargin } from '../components/form/general';

import AuthUserContainer from '../containers/AuthUser';
import TicketContainer from '../containers/Ticket/Ticket';
import PtoRequiredRequestContainer from '../containers/RequiredPtoRequest';

import ticketsColoredIcon from '../images/icons/ticketsColored.svg';
import coloredCalendarIcon from '../images/icons/coloredCalendar.svg';
import ptoColoredIcon from '../images/icons/ptoColored.svg';
import connectedIcon from '../images/icons/connected.svg';
import coloredShiftAuditIcon from '../images/icons/ShiftAudit.svg';
import accountingIcon from '../images/icons/accountingColored.svg';
import timeClockColoredIcon from '../images/icons/timeClockColored.svg';
import advancedScheduleIcon from '../images/icons/advancedSchedule.svg';
import goDigitalIcon from '../images/icons/goDigital.svg';

import mixMatchIcon from '../images/icons/mixMatch.svg';
import timelineIcon from '../images/icons/timeline.svg';
import workflowIcon from '../images/icons/workflow.svg';
import scanDocumentIcon from '../images/icons/scanDocumentIcon.svg';
import printedDeliveryTicketsIcon from '../images/icons/printedDeliveryTickets.svg';
import sphereMobileIcon from '../images/icons/sphereMobile.svg';

import WarningIconSvg from '../images/icons/warningIcon.svg';
import Note from '../components/Note';
import FormSubmitButton from '../components/form/FormSubmitButton';
import JustSphereLogo from '../images/logos/justSphere.svg';
import GreenChecked from '../images/icons/greenChecked.svg';
import RecentShifts from '../components/timeClock/recentShifts';
import ClockInAndOut from '../components/timeClock/clockInAndOut';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		welcomeContainer: {
			display: 'flex',
			alignItems: 'center',
			marginBottom: 15,
			marginTop: 10,
		},
		welcomeText: {
			textTransform: 'uppercase',
			fontFamily: "'Roboto Condensed', sans-serif",
			fontSize: 50,
			color: '#333',
			marginLeft: 5,
		},
		justSphereLogo: {
			display: 'inline-block',
			width: 50,
			height: 50,
			backgroundImage: `url('${JustSphereLogo}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 5,
			marginLeft: 5,
		},
		contentTitle: {
			display: 'flex',
			alignItems: 'center',
			fontSize: 28,
			borderBottom: '1px solid #ddd',
			paddingBottom: 15,
			marginBottom: 15,
		},
		noOpenTickets: {
			display: 'flex',
			alignItems: 'center',
			fontSize: 18,
		},
		pastUpdates: {
			fontSize: 18,
			borderBottom: '1px solid #ccc',
			paddingBottom: 5,
			marginBottom: 20,
			marginTop: 60,
		},
		content: {
			fontSize: 18,
			paddingLeft: 20,
		},

		iconSection: {
			textAlign: 'center',
		},
		calendarIcon: {
			width: 62,
		},
		ticketIcon: {
			width: 62,
		},
		driverReportIcon: {
			width: 62,
		},
		description: {
			fontSize: 20,
		},
		fetching: {
			fontStyle: 'italic',
			padding: '10px 0px',
			color: '#777',
		},
		releaseNumber: {
			fontWeight: 200,
			textTransform: 'uppercase',
			marginTop: 50,
			fontSize: 20,
			letterSpacing: 2,
			marginBottom: 10,
		},
		warningIcon: {
			color: '#FFC107',
			verticalAlign: 'middle',
			marginRight: 10,
			height: 60,
		},
		titleContainer: {
			display: 'flex',
			flexDirection: 'row',
			fontSize: 30,
			alignItems: 'center',
		},
		greenCheckedIcon: {
			display: 'inline-block',
			width: 20,
			height: 20,
			backgroundImage: `url('${GreenChecked}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 12,
			marginLeft: 0,
			marginTop: 5,
		},
		loginWarning: {
			fontSize: 18,
		},
		boldName: {
			fontSize: '120%',
			fontWeight: 800,
			display: 'inline-block',
			borderBottom: '2px solid #E9791E',
			margin: `0px 5px`,
			paddingBottom: 2,
		},
		p: {
			marginBlockStart: '.5em',
			marginBlockEnd: '.5em',
		},
	};
};

class Dashboard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			order: 'desc',
			orderBy: 'clockInDateTime',
			lastPunchInfoResults: undefined,
			showClockInSuccessful: false,
			showClockOutSuccessful: false,
			recentTimeClockShifts: undefined,
		};
	}

	handleFillOut = ({ requireDriverReportType, ticketId }) => {
		this.props.history.push(`/driver/report/add/${requireDriverReportType}/${ticketId}`);
	};

	handleFillOutPto = () => {
		this.props.history.push(`/pto/request/addRequired`);
	};

	componentDidMount() {
		const { myRequiredPtoRequests, searchRequiredPtoRequests } = this.props;
		if (!myRequiredPtoRequests) {
			searchRequiredPtoRequests({
				params: {
					searchFor: 'myRequests',
				},
			});
		}
	}

	render() {
		const { classes, myTickets, authUser } = this.props;

		if (!myTickets || !authUser) {
			return <div className={classes.fetching}>Fetching tickets...</div>;
		}

		let innerRender =
			authUser.role === 'driver' ? this.renderDriverDashboard : this.renderNonDriverDashboard;

		return (
			<Fragment>
				<div className={classes.welcomeContainer}>
					<div className={classes.justSphereLogo} />
					<div className={classes.welcomeText}>Welcome to Sphere!</div>
				</div>
				{innerRender()}
			</Fragment>
		);
	}

	renderDriverDashboard = () => {
		const { classes, authUser } = this.props;

		return (
			<div>
				<Paper className={classes.globalMainPaper} style={{ padding: '20px 30px' }}>
					<div className={classes.loginWarning}>
						<strong>Note</strong>: If you are not
						<div className={classes.boldName}>
							{' '}
							{authUser.firstName} {authUser.lastName}{' '}
						</div>{' '}
						please log out and log back in under your account
					</div>
				</Paper>

				{this.renderTicketSection()}
				{authUser.userId === 185 && this.renderRequiredPtoRequestSection()}
				{authUser.userClocksInAndOut && (
					<>
						<ClockInAndOut showPrintDeliveryTickets={true} userId={authUser.userId} />
						<RecentShifts />
					</>
				)}
			</div>
		);
	};

	renderTicketSection = () => {
		const { myTickets } = this.props;

		let openTickets = _.filter(myTickets, (ticket) => {
			return ticket.status === 'pendingDriverReport';
		});
		if (_.isEmpty(openTickets)) {
			return null;
		} else {
			return (
				<Fragment>
					{openTickets.map((ticket) => {
						return this.renderTicket({ ticket });
					})}
				</Fragment>
			);
		}
	};

	renderRequiredPtoRequestSection = () => {
		const { classes, myRequiredPtoRequests } = this.props;

		if (_.isEmpty(myRequiredPtoRequests)) {
			return null;
		}

		// lets gather all the dates and IDs and display them

		const allDatesAndHours = [];
		myRequiredPtoRequests.forEach((myRequiredPtoRequest) => {
			allDatesAndHours.push(...myRequiredPtoRequest.dateAndHours);
		});

		const message = (
			<span>
				HR has entered PTO for you on the schedule and this requires a PTO request to be filled out.
				<br />
				Please click the button below to fill out and submit your PTO request. Dates and hours will
				be filled in automatically for you. When submitted this report will be automatically emailed
				to your terminal manager and HR. Thank you.
			</span>
		);

		return (
			<Paper className={classes.globalMainPaper}>
				<div className={classes.titleContainer}>
					<img alt="ticket" src={WarningIconSvg} className={classes.warningIcon} />
					<span>Action Required : PTO Request Required</span>
				</div>
				<Note label={message} />

				<FormSubmitButton
					onClick={() => {
						this.handleFillOutPto();
					}}
					buttonText={`Fill Out PTO Request`}
				/>
			</Paper>
		);
	};

	renderTicket = ({ ticket }) => {
		const { classes } = this.props;

		const { requireDriverReportType, ticketId } = ticket;

		if (!requireDriverReportType) {
			return (
				<Paper key={ticket.ticketId} className={classes.globalMainPaper}>
					You have a ticket assigned to you but it does not require a report to be filled out.
					Please let support know about this.
				</Paper>
			);
		}

		const rt = _.capitalize(requireDriverReportType);

		const message = (
			<span>
				There is a new ticket opened that requires a {rt} Form from you.
				<br />
				<br />
				Please click the button below to fill out and submit your <strong>{rt} Report</strong>. When
				submitted this report will be automatically emailed and attached to the ticket. Thank you.
			</span>
		);

		return (
			<Paper key={ticketId} className={classes.globalMainPaper}>
				<div className={classes.titleContainer}>
					<img alt="ticket" src={WarningIconSvg} className={classes.warningIcon} />
					<span>Action Required</span>
				</div>
				<Note label={message} />

				<FormSubmitButton
					onClick={() => {
						this.handleFillOut({ requireDriverReportType, ticketId });
					}}
					buttonText={`Fill Out Report`}
				/>
			</Paper>
		);
	};

	handleSort = (orderBy) => {
		let order = 'desc';
		if (this.state.orderBy === orderBy && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order: order, orderBy: orderBy });
	};

	renderNonDriverDashboard = () => {
		const { classes } = this.props;
		return (
			<Fragment>
				{this.renderTicketSection()}
				<Paper className={classes.globalMainPaper}>
					<div className={classes.contentTitle}>Whats new in Sphere</div>

					<div className={classes.content}>
						<div className={classes.releaseNumber}>
							Release 18! - Williams Tank Lines Support & TMW Migration
						</div>
						<Grid spacing={2} container>
							<Grid item xs={12} md={1} style={gridMargin}>
								<div className={classes.iconSection}>
									<img alt="workflow" src={workflowIcon} className={classes.calendarIcon} />
								</div>
							</Grid>
							<Grid item xs={12} md={10} style={gridMargin}>
								<div className={classes.description}>
									Big release! We have been hard at work deprecating TMW from multiple areas across
									Sphere and replacing it with our own native data and workflows. This is a major
									step forward in Sphere becoming a fully self-sufficient platform.
									<p className={classes.p}>
										At the same time, we have rolled out extensive support for{' '}
										<strong>Williams Tank Lines</strong> users. Williams drivers, dispatchers, and
										office staff are now fully integrated into Sphere — including ticketing,
										scheduling, time clocks, mobile, and reporting — all under the Williams Tank
										Lines fleet.
									</p>
								</div>
							</Grid>
						</Grid>
					</div>

					<div className={classes.pastUpdates}>Past Updates</div>

					<div className={classes.content}>
						<div className={classes.releaseNumber}>Release 17! - Customer Paperwork Delivery</div>
						<Grid spacing={2} container>
							<Grid item xs={12} md={1} style={gridMargin}>
								<div className={classes.iconSection}>
									<Link to={'/scheduling/schedule/users'}>
										<img
											alt="unification"
											src={coloredShiftAuditIcon}
											className={classes.calendarIcon}
										/>
									</Link>
								</div>
							</Grid>
							<Grid item xs={12} md={10} style={gridMargin}>
								<div className={classes.description}>
									The Sphere system will now email customers mapped in our system after a driver
									completes their shift. This email will include all essential Sphere mobile scans
									of their Veeder and BOL information, along with delivery details.
								</div>
							</Grid>
						</Grid>
					</div>

					<div className={classes.content}>
						<div className={classes.releaseNumber}>
							Release 16.5! - San Diego and Long Beach Terminal Launch
						</div>
						<Grid spacing={2} container>
							<Grid item xs={12} md={1} style={gridMargin}>
								<div className={classes.iconSection}>
									<Link to={'/scheduling/schedule/users'}>
										<img alt="unification" src={connectedIcon} className={classes.calendarIcon} />
									</Link>
								</div>
							</Grid>
							<Grid item xs={12} md={10} style={gridMargin}>
								<div className={classes.description}>
									Minor update, but a big one as we added two more terminals! Welcome San Diego and
									welcome to Long Beach. They can be found under SD and LB and San Diego will share
									the similar setup as Colton and Long Beach will mirror Paramount.
								</div>
							</Grid>
						</Grid>
					</div>

					<div className={classes.content}>
						<div className={classes.releaseNumber}>
							Release 16.0! - Company Wide Schedules Phase One
						</div>
						<Grid spacing={2} container>
							<Grid item xs={12} md={1} style={gridMargin}>
								<div className={classes.iconSection}>
									<Link to={'/scheduling/schedule/users'}>
										<img
											alt="unification"
											src={advancedScheduleIcon}
											className={classes.calendarIcon}
										/>
									</Link>
								</div>
							</Grid>
							<Grid item xs={12} md={10} style={gridMargin}>
								<div className={classes.description}>
									We have significantly improved our scheduling system, extending beyond just
									drivers to include all departments in the scheduling process. This integration
									ensures that all teams are aligned, leading to more efficient operations and
									better coordination across the company. By incorporating all departments into the
									scheduling process, we can now manage resources and workloads more effectively.
									<p className={classes.p}>
										This is only phase one of our enhanced scheduling initiative. In the coming
										months, we will be adding even more employee-centric features to further
										streamline and optimize the scheduling process.
									</p>
								</div>
							</Grid>
						</Grid>
					</div>

					<div className={classes.content}>
						<div className={classes.releaseNumber}>Release 15.0! - Eugene + Paperless Phase 1</div>
						<Grid spacing={2} container>
							<Grid item xs={12} md={1} style={gridMargin}>
								<div className={classes.iconSection}>
									<Link to={'/accounting/unbilledOrders'}>
										<img alt="unification" src={goDigitalIcon} className={classes.calendarIcon} />
									</Link>
								</div>
							</Grid>
							<Grid item xs={12} md={10} style={gridMargin}>
								<div className={classes.description}>
									New location is now live across Sphere. This means that it can now be used in
									ticketing assignments, scheduling, time clocks, user assignments, and any other
									place the fleet / terminal can be currently selected.
									<p className={classes.p}>
										Eugene will be scanning documents, just like the rest of our orders. We have
										introduced a new feature that allows all scanned documents to be downloaded into
										a single PDF. Billing can access this feature on the billing table by clicking
										on the documents and then selecting the large “Download Bundle PDF” button.
										<br />
										This is only phase one of our initiative to go paperless across the fleet.
										Further enhancements and features will be rolled out in the coming months to
										streamline our processes and reduce paper usage.
									</p>
								</div>
							</Grid>
						</Grid>
					</div>

					<div className={classes.content}>
						<div className={classes.releaseNumber}>
							Release 14.0! - Sphere Mobile Document Scanning
						</div>
						<Grid spacing={2} container>
							<Grid item xs={12} md={1} style={gridMargin}>
								<div className={classes.iconSection}>
									<Link to={'/scheduling/schedule/users'}>
										<img
											alt="unification"
											src={scanDocumentIcon}
											className={classes.calendarIcon}
										/>
									</Link>
								</div>
							</Grid>
							<Grid item xs={12} md={10} style={gridMargin}>
								<div className={classes.description}>
									Excited to announce the Sphere mobile app has proudly launched its document
									scanning feature in Phase 2, leveraging our mobile devices for efficient
									digitization of various documents.
									<p className={classes.p}>
										This enhancement integrates right into our product update feature AND we have
										integrated this into billing to provide the updated documents right in the
										invoice dashboard.
										<br />
										Note: This is in BETA and will slowly be rolling out to select uses.
									</p>
								</div>
							</Grid>
						</Grid>
					</div>

					<div className={classes.content}>
						<div className={classes.releaseNumber}>Release 13.0! - Sphere Mobile!</div>
						<Grid spacing={2} container>
							<Grid item xs={12} md={1} style={gridMargin}>
								<div className={classes.iconSection}>
									<Link to={'/scheduling/schedule/users'}>
										<img
											alt="unification"
											src={sphereMobileIcon}
											className={classes.calendarIcon}
										/>
									</Link>
								</div>
							</Grid>
							<Grid item xs={12} md={10} style={gridMargin}>
								<div className={classes.description}>
									Finally a MobileCom solution for all our driver's to use that fuses the features
									of Sphere with the backend data of TMW. Phase one is complete and allows drivers
									to get all tickets digitally, reported delays, and enter product data.
									<p className={classes.p}>
										There will be multiple phases of Sphere Mobile to come. In the upcoming phases
										we will introduce consignee delays, loading numbers, journey plans, document
										scanning and more. The goal of Sphere mobile is to be the ultimate MobileCom
										solution for our drivers.
									</p>
								</div>
							</Grid>
						</Grid>
					</div>

					<div className={classes.content}>
						<div className={classes.releaseNumber}>Release 12.0! - Printed Delivery Tickets</div>
						<Grid spacing={2} container>
							<Grid item xs={12} md={1} style={gridMargin}>
								<div className={classes.iconSection}>
									<img
										alt="unification"
										src={printedDeliveryTicketsIcon}
										className={classes.calendarIcon}
									/>
								</div>
							</Grid>
							<Grid item xs={12} md={10} style={gridMargin}>
								<div className={classes.description}>
									Now we have our very own delivery tickets printed directly from Sphere. Drivers
									can login with Sphere, clock in, and quickly print their delivery loads for the
									day.
									<p className={classes.p}>
										Sphere now syncs with TMW and grabs all this information from our dispatch
										system. The driver no longer has to visit dispatch for their collected tickets.
										This TMW integration is the stepping stone for Sphere Mobile.
									</p>
								</div>
							</Grid>
						</Grid>

						<div className={classes.releaseNumber}>Release 11.0! - Schedule Unification</div>
						<Grid spacing={2} container>
							<Grid item xs={12} md={1} style={gridMargin}>
								<div className={classes.iconSection}>
									<Link to={'/scheduling/schedule/users'}>
										<img alt="unification" src={connectedIcon} className={classes.calendarIcon} />
									</Link>
								</div>
							</Grid>
							<Grid item xs={12} md={10} style={gridMargin}>
								<div className={classes.description}>
									Finally one schedule to rule them all. We have implemented a backend process that
									will take all our statuses from our Sphere Schedule and it will sync them with
									TMW.
									<p className={classes.p}>
										This unification happens behind the scenes and runs every 10 minutes to keep our
										schedules as up to date as possible. This will not update anything that less
										than 36 hours out to allow for quick updates to TMW for day of updates from
										dispatch.
									</p>
								</div>
							</Grid>
						</Grid>

						<div className={classes.releaseNumber}>Release 10.0! - PTO Streamlined</div>
						<Grid spacing={2} container>
							<Grid item xs={12} md={1} style={gridMargin}>
								<div className={classes.iconSection}>
									<Link to={'/pto/request/dashboard'}>
										<img alt="pto" src={ptoColoredIcon} className={classes.calendarIcon} />
									</Link>
								</div>
							</Grid>
							<Grid item xs={12} md={10} style={gridMargin}>
								<div className={classes.description}>
									We have taken the old paper forms, signatures, and multiple scans and moved
									everything digital for all the company's PTO needs.
									<p className={classes.p}>
										A driver or office employee can now just login to Sphere and navigate to the PTO
										requests section and open a new PTO request. All hours are calculated and added
										up for the employee and they can sign digitally with the form. This then kicks
										off an email to their manager for approval, which then kicks off an email to HR
										for approval and all approvals or denys can be done with a single click.
										<p className={classes.p}>
											The entire time an employee can check on their PTO status and does not have to
											bug supervisors any more for updates. The entire process is tracked through
											Sphere for efficiency and a full log is kept with any notes and updates along
											the way.
										</p>
									</p>
								</div>
							</Grid>
						</Grid>
					</div>

					<div className={classes.content}>
						<div className={classes.releaseNumber}>Release 9.0! - Xenocomm Integration</div>
						<Grid spacing={2} container>
							<Grid item xs={12} md={1} style={gridMargin}>
								<div className={classes.iconSection}>
									<Link to={'/timeClock'}>
										<img alt="ticket" src={workflowIcon} className={classes.calendarIcon} />
									</Link>
								</div>
							</Grid>
							<Grid item xs={12} md={10} style={gridMargin}>
								<div className={classes.description}>
									This release integrates the Sphere system with our Xenocomm emails and gives us
									the ability to automatically create delay, demurrage, and retain tickets from
									driver reports.
									<p className={classes.p}>
										When a driver submits a XenoComm report Sphere processes these emails and
										extracts the TWM information and reason for delay / demurrage. Then it
										auto-creates a ticket and pulls the relevant TMW information for the ticket.
										Tickets and then automatically linked to Billing where they can charge for the
										retain.
									</p>
								</div>
							</Grid>
						</Grid>
					</div>

					<div className={classes.content}>
						<div className={classes.releaseNumber}>Release 8.0! - Attendance Updates</div>

						<Grid spacing={2} container>
							<Grid item xs={12} md={1} style={gridMargin}>
								<div className={classes.iconSection}>
									<Link to={'/scheduling/schedule/users'}>
										<img alt="schedule" src={timelineIcon} className={classes.calendarIcon} />
									</Link>
								</div>
							</Grid>
							<Grid item xs={12} md={10} style={gridMargin}>
								<div className={classes.description}>
									This release updated our scheduling and ticketing to better capture our driver's
									attendance.
									<p className={classes.p}>
										New scheduling statuses added : PTO, Call Out, No Call / No Show, FMLA, Workers
										Comp, and LOA and some statuses are controlled by HR/Safety permissions.
									</p>
									<p className={classes.p}>
										Ticketing also got updates. Now with just a check of a box dispatch / TMs can
										update their schedule straight from creating a ticket. All of these tickets also
										add a note to the schedule that shows the ticket number that caused the change,
										who opened the ticket, and the details of the ticket.
									</p>
								</div>
							</Grid>
						</Grid>

						<div className={classes.releaseNumber}>Release 7.0! - Shift Audits</div>

						<Grid spacing={2} container>
							<Grid item xs={12} md={1} style={gridMargin}>
								<div className={classes.iconSection}>
									<Link to={'/timeClock'}>
										<img
											alt="ticket"
											src={coloredShiftAuditIcon}
											className={classes.calendarIcon}
										/>
									</Link>
								</div>
							</Grid>
							<Grid item xs={12} md={10} style={gridMargin}>
								<div className={classes.description}>
									This release set our time clocks live and introduced our realtime shift audits to
									help prevent invalid shifts.
									<p className={classes.p}>
										Sphere now runs in the background analyzing every shift that comes through to
										help prevent violations with drivers with state laws and help employees go into
										their meals.
									</p>
									<p className={classes.p}>
										Flagged shifts and automatically emailed to supervisors and the process is in
										place for clearing those flags and fixing the shift. All of this makes a
										seamless process for HR to stay on top of pay roll with correct shifts.
									</p>
								</div>
							</Grid>
						</Grid>

						<div className={classes.releaseNumber}>Release 6.0! - V2 Updates</div>
						<Grid spacing={2} container>
							<Grid item xs={12} md={1} style={gridMargin}>
								<div className={classes.iconSection}>
									<Link to={'/scheduling/schedule/users'}>
										<img alt="ticket" src={mixMatchIcon} className={classes.calendarIcon} />
									</Link>
								</div>
							</Grid>
							<Grid item xs={12} md={10} style={gridMargin}>
								<div className={classes.description}>
									This release was a collection of updates to our core tools that we use day to day.
									<p className={classes.p}>
										Scheduling got a revamp and we added open time slots, new truck management
										features, and streamlined out driver schedule for TMs.
									</p>
									<p className={classes.p}>
										Accounting got new integrations with TMW Imaging, GeoTab linkage, and new
										automated audits have bgeen added to our list.
									</p>
									<p className={classes.p}>
										Time clocks have grown since v1 with new dashboard features, ability to group
										shifts by the same day, more export features, and a daily emailed export to the
										team.
									</p>
								</div>
							</Grid>
						</Grid>

						<div className={classes.releaseNumber}>Release 5.0! - Time Clocks</div>
						<Grid spacing={2} container>
							<Grid item xs={12} md={1} style={gridMargin}>
								<div className={classes.iconSection}>
									<Link to={'/accounting'}>
										<img alt="ticket" src={timeClockColoredIcon} className={classes.calendarIcon} />
									</Link>
								</div>
							</Grid>
							<Grid item xs={12} md={10} style={gridMargin}>
								<div className={classes.description}>
									Clocking in and out now happens all through Sphere. And we have smart time rules
									in place now for drivers to catch and avoid situations like early clock in and
									working too many hours before a break.
									<p className={classes.p}>
										Full admin functionality so TMs and mangers can be in full control and get
										reports on recent activity to make sure their team is running efficiently. Even
										integrates with ExponentHR for time shifts and TMW to mark people on / off duty.
									</p>
								</div>
							</Grid>
						</Grid>
					</div>

					<div className={classes.content}>
						<div className={classes.releaseNumber}>Release 4.0! - Accounting</div>
						<Grid spacing={2} container>
							<Grid item xs={12} md={1} style={gridMargin}>
								<div className={classes.iconSection}>
									<Link to={'/accounting'}>
										<img alt="ticket" src={accountingIcon} className={classes.calendarIcon} />
									</Link>
								</div>
							</Grid>
							<Grid item xs={12} md={10} style={gridMargin}>
								<div className={classes.description}>
									Migrated all the Unbilled orders and invoices to Sphere.
									<br />
									Used to live on a shared spreadsheet that took minutes to load, now its just
									seconds. Added search parameters with smart memory between reloads, table
									filtering, keyboard shortcuts, and quick copy & paste functionality right in
									Sphere. Billers can now do their job at super speed.
								</div>
							</Grid>
						</Grid>
					</div>

					<div className={classes.content}>
						<div className={classes.releaseNumber}>Release 3.0! - Scheduling</div>
						<Grid spacing={2} container>
							<Grid item xs={12} md={1} style={gridMargin}>
								<div className={classes.iconSection}>
									<Link to={'/scheduling'}>
										<img alt="ticket" src={coloredCalendarIcon} className={classes.calendarIcon} />
									</Link>
								</div>
							</Grid>
							<Grid item xs={12} md={10} style={gridMargin}>
								<div className={classes.description}>
									Full scheduling functionality to run the business.
									<br />
									All trucks are now fully imported via GeoTabs and synced with Sphere. Trucks are
									all assigned through truck assignments, then drivers are assigned to those trucks
									and the A-B-C schedule is picked and it all fits together.
								</div>
							</Grid>
						</Grid>
					</div>

					<div className={classes.content}>
						<div className={classes.releaseNumber}>Release 2.0! - Ticketing</div>
						<Grid spacing={2} container>
							<Grid item xs={12} md={1} style={gridMargin}>
								<div className={classes.iconSection}>
									<Link to={'/ticket/list'}>
										<img alt="ticket" src={ticketsColoredIcon} className={classes.ticketIcon} />
									</Link>
								</div>
							</Grid>
							<Grid item xs={12} md={10} style={gridMargin}>
								<div className={classes.description}>
									Brand new ticketing system has been added in this version.
									<br />
									You can open tickets by visiting the <Link to={'/ticket/list'}>Tickets </Link>
									section and click the "Open Ticket" button.
									<br />
									You can also see a list of all tickets open in the system and easily see all the
									tickets assigned you in the by clicking on the{' '}
									<Link to={'/ticket/list'}>My Tickets</Link> menu item.
								</div>
							</Grid>
						</Grid>
					</div>

					<div className={classes.content}>
						<div className={classes.releaseNumber}>First Release! Version 1.0.</div>
						<Grid spacing={2} container>
							<Grid item xs={12} md={1} style={gridMargin}>
								<div className={classes.iconSection}>
									<Link to={'/driver/pickReport'}>
										<img
											alt="driverReport"
											src={driverReportIcon}
											className={classes.driverReportIcon}
										/>
									</Link>
								</div>
							</Grid>
							<Grid item xs={12} md={10} style={gridMargin}>
								<div className={classes.description}>
									Driver reports have been added to this version. To create a new driver report head
									on over to the <Link to={'/driver/pickReport'}>Driver Reports</Link> section to
									fill out any needed reports for incidents that happened on the job.
								</div>
							</Grid>
						</Grid>
					</div>
				</Paper>
			</Fragment>
		);
	};
}

Dashboard.propTypes = {
	authUser: PropTypes.object,
};

export default _.flow([
	withStyles(styles),
	AuthUserContainer,
	TicketContainer,
	PtoRequiredRequestContainer,
])(Dashboard);
